<template>
  <div class="border-t--1px">
    <page-title label="MY PAGE"></page-title>

    <form
      class="max-w--800px m--auto mypage pt--20px px--16px"
      @submit.prevent="submit"
    >
      <profile
        class="mypage__profile"
        :userId="origin.userId"
        :userName="origin.userName"
        :email="origin.email"
        :role="origin.role"
        v-model="row.avatar"
      />

      <div class="myinfo__body pt--60px">
        <h2 class="font--18px pb--24px mb--16px border-b--1px">개인정보 수정</h2>
        <div
          class="info__modified clearfix"
          @input="error.errorMessage = ''"
        >
          <my-page-input
            v-model="row.userId"
            :error="error"
            name="userId"
            label="아이디"
            :readonly="true"
          />
          <my-page-input
            v-model="row.userName"
            :error="error"
            name="userName"
            label="이름"
          />
          <my-page-input
            v-model="row.email"
            :error="error"
            :readonly="true"
            name="email"
            label="이메일"
            helpText=""
          />
          <my-page-input
            v-model="row.passwordOld"
            :error="error"
            name="passwordOld"
            label="기존 비밀번호"
            type="password"
          />
          <my-page-input
            v-model="row.password"
            :error="error"
            name="password"
            label="새 비밀번호"
            type="password"
          />
          <my-page-input
            v-model="row.passwordConfirm"
            :error="error"
            name="passwordConfirm"
            label="새 비밀번호 확인"
            type="password"
          />

          <div class="clearfix event__reception py--20px">
            <div class="col-m-2 p--0px">
              <p class="font--14px text--gray mt--8px">이벤트 수신여부</p>
            </div>
            <div class="col-m-10">
              <div class="float--left mr--30px">
                <p class="font--14px">이메일, SMS 수신 서비스를 받아보시겠습니까?</p>
                <span class="font--12px text--gray">* 이벤트, 프로모션 등 다양한 정보를 전달 드립니다.</span>
              </div>
              <div class="overflow-hidden event__btn-group">
                <form-button
                  label="동의함"
                  class="border btn--sm radius--round btn-event"
                  :class="row.emailFlag === 'Y' ? 'black text--white' : ''"
                  @click.prevent="row.emailFlag = 'Y'"
                ></form-button>
                <form-button
                  label="동의안함"
                  class="border btn--sm radius--round btn-event ml--8px"
                  :class="row.emailFlag === 'N' ? 'black text--white' : ''"
                  @click.prevent="row.emailFlag = 'N'"
                ></form-button>
              </div>
            </div>
          </div>
        </div>
        <div class="text--center py--40px border-t--1px mt--16px">
          <form-button
            @click="$router.push({name: 'home'})"
            label="취소"
            class="btn btn--xxxl border"
          ></form-button>
          <form-button
            type="submit"
            label="저장"
            class="btn btn--xxxl black text--white ml--8px"
          ></form-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data () {
    return {
      row: {
        emailFlag: ''
      },
      origin: {},
      error: {}
    }
  },
  async created () {
    await this.$load(`/api/users/me`)
  },
  methods: {
    checkPassword () {
      let res = (this.row.password || this.row.passwordOld) && (!this.row.password || this.row.password !== this.row.passwordConfirm)
      if (res) {
        window.scrollTo(0, 0)
        const error = {
          fieldId: 'password',
          errorMessage: '패스워드가 일치하지 않습니다.'
        }
        throw error
      }
    },
    async submit () {
      try {
        this.checkPassword()
        let ret = await this.$update(`/api/users/${this.row.userId}`)
        if (!ret) {
          return
        }
        ret = confirm('저장 되었습니다. 홈으로 이동하시겠습니까?')
        if (ret) {
          this.$store.dispatch('GET_ME')
          this.$router.push({ name: 'home' })
        }
      } catch (error) {
        this.error = error
      }
    },
    async withdrawal () {
      const ret = confirm('정말 회원 탈퇴하시겠습니까?')
      if (!ret) {
        return
      }
      try {
        await this.$http.delete('/api/auth/withdrawal')
        this.$store.commit('SET_USER_INFO', {})
        this.$router.push({ name: 'withdrawal' })
      } catch (ex) {
        console.log(ex)
        alert('문제가 발생하였습니다.')
      }
    }
  },
  components: {
    MyPageInput: () => import('./component/MyPageInput'),
    Profile: () => import('@/component/common/Profile'),
    PageTitle: () => import('@/app/user/component/PageTitle'),
    // MainContainer: () => import('@/component/container/MainContainer'),
    FormButton: () => import('@/component/ui2/button/FormButton')
  }

}
</script>
